import { post } from '@media-ui/core/src/tools/transport';
export const getTestResult = (url: string, answers: [
]) => {
    return post(url, {
        answers,
    });
};
